import React from 'react';
import styled, { css } from 'styled-components';

export const EditorPanelContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 350px;
  min-height: 66px;
  background: #f3f4f6;
  border: 1px solid #dedede;
  box-sizing: border-box;
  border-radius: 5px;
  margin-bottom: 20px;
  cursor: pointer;

  ${props =>
    props.expanded &&
    css`
      height: 328px;
      padding: 0px 30px 25px 30px;
      cursor: default;
    `}
`;

function EditorCard(props) {
  return (
    <EditorPanelContainer
      id={props.id}
      expanded={props.expanded}
      onClick={props.onClick}
    >
      {props.children}
    </EditorPanelContainer>
  );
}

export default EditorCard;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/EditorCard/editor-card.jsx